import { CALL_API } from "redux-api-middleware";
import { reset } from "redux-form";
import {
  REQUEST_USER_LOGIN,
  RECEIVE_USER_LOGIN,
  ERROR_USER_LOGIN,
  REQUEST_FORGOT_PASSWORD,
  RECEIVE_FORGOT_PASSWORD,
  ERROR_FORGOT_PASSWORD,
  REQUEST_USER_PROFILE,
  RECEIVE_USER_PROFILE,
  ERROR_USER_PROFILE,
  REQUEST_USER_PROFILE_UPDATE,
  RECEIVE_USER_PROFILE_UPDATE,
  ERROR_USER_PROFILE_UPDATE,
  REQUEST_CHANGE_PASSWORD,
  RECEIVE_CHANGE_PASSWORD,
  ERROR_CHANGE_PASSWORD,
  REQUEST_USER_LOGOUT,
  RECEIVE_USER_LOGOUT,
  ERROR_USER_LOGOUT,
  REQUEST_MAINTENANCE_CARDS,
  RECEIVE_MAINTENANCE_CARDS,
  ERROR_MAINTENANCE_CARDS,
  REQUEST_INTERNET_USER_LIST,
  RECEIVE_INTERNET_USER_LIST,
  ERROR_INTERNET_USER_LIST,
  REQUEST_LOGIN_STATISTICS,
  RECEIVE_LOGIN_STATISTICS,
  ERROR_LOGIN_STATISTICS,
  REQUEST_USER_INFO,
  RECEIVE_USER_INFO,
  ERROR_USER_INFO,
  REQUEST_SEND_PASSWORDLINK,
  RECEIVE_SEND_PASSWORDLINK,
  ERROR_SEND_PASSWORDLINK,
  CLEAR_INTERNET_USER,
  REQUEST_ALL_CUSTOMERS,
  RECEIVE_ALL_CUSTOMERS,
  ERROR_ALL_CUSTOMERS,
  REQUEST_ALL_SURVEYTYPES,
  RECEIVE_ALL_SURVEYTYPES,
  ERROR_ALL_SURVEYTYPES,
  REQUEST_ADD_COMPANY,
  RECEIVE_ADD_COMPANY,
  ERROR_ADD_COMPANY,
  REQUEST_DELETE_COMPANY,
  RECEIVE_DELETE_COMPANY,
  ERROR_DELETE_COMPANY,
  REQUEST_ADD_AGENCY,
  RECEIVE_ADD_AGENCY,
  ERROR_ADD_AGENCY,
  REQUEST_DELETE_AGENCY,
  RECEIVE_DELETE_AGENCY,
  ERROR_DELETE_AGENCY,
  REQUEST_ALL_RIGHTS,
  RECEIVE_ALL_RIGHTS,
  ERROR_ALL_RIGHTS,
  REQUEST_ADD_RIGHT,
  RECEIVE_ADD_RIGHT,
  ERROR_ADD_RIGHT,
  REQUEST_DELETE_RIGHT,
  RECEIVE_DELETE_RIGHT,
  ERROR_DELETE_RIGHT,
  REQUEST_ALL_ROLES,
  RECEIVE_ALL_ROLES,
  ERROR_ALL_ROLES,
  REQUEST_ALL_MAJOR_COMPANIES,
  RECEIVE_ALL_MAJOR_COMPANIES,
  ERROR_ALL_MAJOR_COMPANIES,
  REQUEST_UPDATE_USER,
  RECEIVE_UPDATE_USER,
  ERROR_UPDATE_USER,
  REQUEST_CREATE_USER,
  RECEIVE_CREATE_USER,
  ERROR_CREATE_USER,
  CLEAR_USER_REDIRECT,
  REQUEST_DISABLE_USER,
  RECEIVE_DISABLE_USER,
  ERROR_DISABLE_USER,
  USER_WILL_LOGOUT,
  REQUEST_LOGIN_KEEP_ALIVE,
  RECEIVE_LOGIN_KEEP_ALIVE,
  ERROR_LOGIN_KEEP_ALIVE,
  REQUEST_TRAINING_SECTIONS,
  RECEIVE_TRAINING_SECTIONS,
  ERROR_TRAINING_SECTIONS
} from "typeConstants";
import { replace } from "tools/navigationService";
import api from "apis/user";
import { clone } from "lodash";
import responseHandler from "responseHandler";
import { abortAll } from "tools/requestTracker";
import { WebApiReduxRequest, HTTP_GET, HTTP_POST, HTTP_DELETE, HTTP_PUT } from "tools/webservice";


const userLogin = (user) => {
  const clientToken = localStorage.getItem("rememberThisClientToken");
  let userWithMfa = { ...user };
  if (clientToken) {
    userWithMfa.multiFactorRememberThisClientToken = clientToken;
  }
  userWithMfa.localOffsetMinutes = new Date().getTimezoneOffset();
  return (dispatch, getState) => {
    const { returnUrl } = getState().user;
    if (userWithMfa) {
      userWithMfa.returnUrl = returnUrl;
    }
    dispatch({
      [CALL_API]: {
        endpoint: api.loginMultiFactor(),
        method: HTTP_POST,
        body: JSON.stringify(userWithMfa),
        types: [
          REQUEST_USER_LOGIN,
          {
            type: RECEIVE_USER_LOGIN,
            payload: (action, state, res) =>
              res.json()
                .then((data) => {
                  return data;
                })
          },
          {
            type: ERROR_USER_LOGIN,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const clearRedirect = () => {
  return dispatch => (
    dispatch({
      type: CLEAR_USER_REDIRECT,
      payload: {}
    }));
};

const persistLogin = () => {
  return (dispatch) => (
    dispatch({
      [CALL_API]: {
        endpoint: api.persistLogin(),
        method: HTTP_POST,
        credentials: "include",
        types: [
          REQUEST_USER_LOGIN,
          {
            type: RECEIVE_USER_LOGIN,
            payload: (action, state, res) =>
              res.json()
                .then((data) => data)
          },
          {
            type: ERROR_USER_LOGIN,
            payload: () => {
              // this call should never toast
            }
          }
        ]
      }
    })
  );
};

const forgotPassword = (username) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.forgotPassword(username),
        method: HTTP_POST,
        types: [
          REQUEST_FORGOT_PASSWORD,
          {
            type: RECEIVE_FORGOT_PASSWORD,
            payload: (action, state, res) =>
              res.json()
                .then(() => {
                  return Promise.all([
                    dispatch(reset("Login")),
                    responseHandler.success("Password reset email has been sent successfully", dispatch)
                  ]);
                })
          },
          {
            type: ERROR_FORGOT_PASSWORD,
            payload: (action, state, res) => (
              responseHandler.error(res, dispatch)
            )
          }
        ]
      }
    })
  );
};

const getUserProfile = () => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.getProfile(),
        method: HTTP_GET,
        types: [
          REQUEST_USER_PROFILE,
          {
            type: RECEIVE_USER_PROFILE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_USER_PROFILE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

const updateUserProfile = (user) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.updateProfile(),
        method: HTTP_POST,
        body: JSON.stringify(user),
        types: [
          REQUEST_USER_PROFILE_UPDATE,
          {
            type: RECEIVE_USER_PROFILE_UPDATE,
            payload: () => {
              responseHandler.success("Profile has been updated successfully", dispatch);
            }
          },
          {
            type: ERROR_USER_PROFILE_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

const changePassword = (userPassword, successCallback = () => { }) => {
  const userData = clone(userPassword);
  return (dispatch, getState) => {
    delete userData.confirmNewPassword;
    userData.username = getState().user.profile.username;
    return dispatch({
      [CALL_API]: {
        endpoint: api.changePassword(),
        method: HTTP_POST,
        body: JSON.stringify(userData),
        types: [
          REQUEST_CHANGE_PASSWORD,
          {
            type: RECEIVE_CHANGE_PASSWORD,
            payload: () => {
              dispatch(reset("ChangePassword"));
              setTimeout(() => {
                responseHandler.success("Password has been changed successfully", dispatch);
                sessionStorage.setItem("MustChangePassword", false);
                history.push("/redirect");
                successCallback();
              }, 0);
            }
          },
          {
            type: ERROR_CHANGE_PASSWORD,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const userLogout = () => {

  return (dispatch) => {
    dispatch({
      type: USER_WILL_LOGOUT,
    });

    // Using setTimeout here so components looking at state.user.willLogOut have time to act before logout
    setTimeout(() => {
      // Abort all requests and clear all tracked requests.
      abortAll();

      dispatch({
        [CALL_API]: {
          endpoint: api.logout(),
          method: HTTP_POST,
          types: [
            REQUEST_USER_LOGOUT,
            {
              type: RECEIVE_USER_LOGOUT,
              payload: (action, state, res) =>
                res.json()
                  .then((data) => {
                    replace("/login");
                    setTimeout(() => {
                      document.body.classList = ""; // removes any themeing we might have applied so we go back to light theme
                      responseHandler.success(data.message, dispatch);
                      sessionStorage.clear();
                    }, 0);
                  })
            },
            {
              type: ERROR_USER_LOGOUT,
              payload: (action, state, res) => {
                responseHandler.error(res, dispatch);
              }
            }
          ]
        }
      });
    }, 1000);
  };
};

const loginKeepAlive = () => {
  return function (dispatch) {

    dispatch({
      [CALL_API]:
          {
            endpoint: api.loginKeepAlive(),
            method: HTTP_POST,
            types: [
              {
                type: REQUEST_LOGIN_KEEP_ALIVE,
                payload: ""
              },
              {
                type: RECEIVE_LOGIN_KEEP_ALIVE,
                payload: (action, state, res) =>
                    res.json()
                        .then(data => {
                          return data;
                        })
              },
              {
                type: ERROR_LOGIN_KEEP_ALIVE,
                payload: (action, state, res) => {
                  responseHandler.error(res, dispatch);
                }
              }
            ]
          }
    });
  };
};

const getMaintenanceSections = () => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.getMaintenanceSections(),
        method: HTTP_GET,
        types: [
          REQUEST_MAINTENANCE_CARDS,
          {
            type: RECEIVE_MAINTENANCE_CARDS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_MAINTENANCE_CARDS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

const getInternetUserList = (search) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]:
      {
        endpoint: api.getInternetUserList(search),
        method: HTTP_GET,
        types: [
          REQUEST_INTERNET_USER_LIST,
          {
            type: RECEIVE_INTERNET_USER_LIST,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_INTERNET_USER_LIST,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getLoginStatistics = (internetUserId) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]:
      {
        endpoint: api.getLoginStatistics(internetUserId),
        method: HTTP_GET,
        types: [
          {
            type: REQUEST_LOGIN_STATISTICS,
            payload: internetUserId
          },
          {
            type: RECEIVE_LOGIN_STATISTICS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_LOGIN_STATISTICS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getUser = (id) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]:
      {
        endpoint: api.getUser(id),
        method: HTTP_GET,
        types: [
          REQUEST_USER_INFO,
          {
            type: RECEIVE_USER_INFO,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_USER_INFO,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const sendPasswordResetLink = (username) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]:
      {
        endpoint: api.forgotPassword(username),
        method: HTTP_POST,
        types: [
          REQUEST_SEND_PASSWORDLINK,
          {
            type: RECEIVE_SEND_PASSWORDLINK,
            payload: (action, state, res) => {
              res.json()
                .then(data => {
                  setTimeout(() => {
                    let message = "Reset Password Link Sent";
                    responseHandler.success(message, dispatch);
                  }, 0);
                  return data;
                });
            }
          },
          {
            type: ERROR_SEND_PASSWORDLINK,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const clearInternetUser = () => {
  return dispatch => (
    dispatch({
      type: CLEAR_INTERNET_USER
    }));
};

const getAllCustomers = () => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.allCustomers(),
        method: HTTP_GET,
        types: [
          REQUEST_ALL_CUSTOMERS,
          {
            type: RECEIVE_ALL_CUSTOMERS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_ALL_CUSTOMERS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getAllSurveyTypes = () => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.allSurveyTypes(),
        method: HTTP_GET,
        types: [
          REQUEST_ALL_SURVEYTYPES,
          {
            type: RECEIVE_ALL_SURVEYTYPES,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_ALL_SURVEYTYPES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const addCompany = (internetUserId, customerNumber) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.addCompany(internetUserId),
        method: HTTP_POST,
        body: JSON.stringify(customerNumber),
        types: [
          REQUEST_ADD_COMPANY,
          {
            type: RECEIVE_ADD_COMPANY,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_ADD_COMPANY,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const deleteCompany = (internetUserId, customerNumber) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.deleteCompany(internetUserId, customerNumber),
        method: HTTP_DELETE,
        types: [
          REQUEST_DELETE_COMPANY,
          {
            type: RECEIVE_DELETE_COMPANY,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_DELETE_COMPANY,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const addAgency = (internetUserId, agencyCode, databaseType) => {
  let dto = { agencyCode: agencyCode, type: databaseType };
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.addAgency(internetUserId),
        method: HTTP_POST,
        body: JSON.stringify(dto),
        types: [
          REQUEST_ADD_AGENCY,
          {
            type: RECEIVE_ADD_AGENCY,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_ADD_AGENCY,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const deleteAgency = (internetUserId, agencyCode, databaseType) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.deleteAgency(internetUserId, agencyCode, databaseType),
        method: HTTP_DELETE,
        types: [
          REQUEST_DELETE_AGENCY,
          {
            type: RECEIVE_DELETE_AGENCY,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_DELETE_AGENCY,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getAllRights = () => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.allRights(),
        method: HTTP_GET,
        types: [
          REQUEST_ALL_RIGHTS,
          {
            type: RECEIVE_ALL_RIGHTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_ALL_RIGHTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const addRight = (internetUserId, rightName, isEnabled) => {
  let dto = { rightName: rightName, isEnabled: isEnabled };
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.addRight(internetUserId),
        method: HTTP_POST,
        body: JSON.stringify(dto),
        types: [
          REQUEST_ADD_RIGHT,
          {
            type: RECEIVE_ADD_RIGHT,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_ADD_RIGHT,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const deleteRight = (internetUserId, rightName) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.deleteRight(internetUserId, rightName),
        method: HTTP_DELETE,
        types: [
          REQUEST_DELETE_RIGHT,
          {
            type: RECEIVE_DELETE_RIGHT,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_DELETE_RIGHT,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getAllRoles = () => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.allRoles(),
        method: HTTP_GET,
        types: [
          REQUEST_ALL_ROLES,
          {
            type: RECEIVE_ALL_ROLES,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_ALL_ROLES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getAllMajorCompanies = () => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.allMajorCompanies(),
        method: HTTP_GET,
        types: [
          REQUEST_ALL_MAJOR_COMPANIES,
          {
            type: RECEIVE_ALL_MAJOR_COMPANIES,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_ALL_MAJOR_COMPANIES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const updateUser = (internetUserId, dto) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.updateUser(internetUserId),
        method: HTTP_PUT,
        body: JSON.stringify(dto),
        types: [
          REQUEST_UPDATE_USER,
          {
            type: RECEIVE_UPDATE_USER,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_UPDATE_USER,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const createUser = (dto) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.createUser(),
        method: HTTP_POST,
        body: JSON.stringify(dto),
        types: [
          REQUEST_CREATE_USER,
          {
            type: RECEIVE_CREATE_USER,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_CREATE_USER,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const setProfile = (payload) => {
  return function (dispatch) {
    dispatch({
      type: RECEIVE_USER_PROFILE,
      payload
    });
  };
};

const disableUser = (internetUserId) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]:
      {
        endpoint: api.disableUser(internetUserId),
        method: HTTP_PUT,
        types: [
          REQUEST_DISABLE_USER,
          {
            type: RECEIVE_DISABLE_USER,
            payload: () => { }
          },
          {
            type: ERROR_DISABLE_USER,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getTrainingSections = () => WebApiReduxRequest(
  REQUEST_TRAINING_SECTIONS,
  RECEIVE_TRAINING_SECTIONS,
  ERROR_TRAINING_SECTIONS,
  HTTP_GET,
  api.getTrainingSections()
);


export {
  userLogin,
  persistLogin,
  forgotPassword,
  getUserProfile,
  updateUserProfile,
  changePassword,
  userLogout,
  loginKeepAlive,
  getMaintenanceSections,
  getInternetUserList,
  getLoginStatistics,
  getUser,
  sendPasswordResetLink,
  clearInternetUser,
  getAllCustomers,
  getAllSurveyTypes,
  addCompany,
  deleteCompany,
  addAgency,
  deleteAgency,
  deleteRight,
  addRight,
  getAllRights,
  getAllRoles,
  getAllMajorCompanies,
  updateUser,
  createUser,
  setProfile,
  clearRedirect,
  disableUser,
  getTrainingSections,
};
